import { APITypes } from "@cur8/api-client";
import { Typography } from "render/ui/presentation/Typography";
import styles from "./styles.module.sass";
import { Trans } from "./trans";

interface DiscountCodeRedeemedProps {
  token: APITypes.DiscountToken;
}

export function DiscountCodeRedeemed({ token }: DiscountCodeRedeemedProps) {
  return (
    <div className={styles.DiscountCode}>
      <Typography
        style={{ textAlign: "left" }}
        variant="subtitle-medium"
        color="subtle"
      >
        <Trans.Title name={token.redeemerName} />
      </Typography>
      <div className={styles.row}>
        <div className={styles.code}>{token.code}</div>
      </div>
    </div>
  );
}
